(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lux-collection')) {
    customElements.define('lux-collection', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        const h = this.querySelector('.lc__heading');
        if (h) this.style.setProperty('--lc-head-font', getComputedStyle(h).fontFamily);

        // quiet reveal as the section scrolls into view
        const items = [...this.querySelectorAll('.lc-reveal')];
        if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches && !(window.Shopify && Shopify.designMode)) {
          this.classList.add('lc--anim');
          this.io = new IntersectionObserver((entries) => entries.forEach((e) => {
            if (e.isIntersecting) { e.target.classList.add('is-in'); this.io.unobserve(e.target); }
          }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
          items.forEach((el) => this.io.observe(el));
        }

        this.addEventListener('click', (e) => {
          const toggle = e.target.closest('[data-qa-toggle]');
          if (toggle) {
            const card = toggle.closest('.lc-card');
            const open = !card.classList.contains('is-open');
            this.closeAll();
            card.classList.toggle('is-open', open);
            toggle.setAttribute('aria-expanded', open);
            if (open) card.querySelector('.lc-qa__size:not(:disabled)')?.focus({ preventScroll: true });
            return;
          }
          const add = e.target.closest('[data-add]');
          if (add && !add.disabled) this.add(add);
        });
        this.onDoc = (e) => { if (!e.target.closest('.lc-card')) this.closeAll(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(); };
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onKey);
      }
      disconnectedCallback() {
        this.io?.disconnect();
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
      }
      closeAll() {
        this.querySelectorAll('.lc-card.is-open').forEach((c) => {
          c.classList.remove('is-open');
          c.querySelector('[data-qa-toggle]')?.setAttribute('aria-expanded', 'false');
        });
      }
      async add(btn) {
        if (this.busy) return;
        this.busy = true;
        btn.classList.add('is-loading');
        let ok = false, msg = 'Could not add to bag. Please try again.';
        try {
          const r = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.add), quantity: 1 }] })
          });
          const d = await r.json().catch(() => ({}));
          ok = r.ok && !d.status;
          if (!ok) msg = d.description || d.message || msg;
        } catch (e) {}
        btn.classList.remove('is-loading');
        this.busy = false;
        if (!ok) return this.toast(msg, true);
        const card = btn.closest('.lc-card');
        this.closeAll();
        const plus = card.querySelector('.lc-plus');
        if (plus) {
          plus.classList.add('is-done');
          plus.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
          setTimeout(() => {
            plus.classList.remove('is-done');
            plus.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
          }, 1800);
        }
        this.toast('Added to bag');
        this.refreshCart();
      }
      toast(msg, isError) {
        const t = this.querySelector('[data-toast]');
        this.querySelector('[data-toast-msg]').textContent = msg;
        t.querySelector('a').hidden = !!isError;
        t.classList.add('is-show');
        clearTimeout(this.tt);
        this.tt = setTimeout(() => t.classList.remove('is-show'), isError ? 3500 : 4000);
      }
      async refreshCart() {
        try {
          const cart = await (await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })).json();
          document.querySelectorAll('.cart-count-badge').forEach((b) => { b.textContent = cart.item_count; b.dataset.count = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-collection-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lux-catalog')) {
    customElements.define('lux-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        // the script can run before the section's markup has been parsed; wait for it
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        this.sectionId = this.dataset.sectionId;
        this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const h = this.querySelector('.lcm-title');
        if (h) this.style.setProperty('--lcm-head-font', getComputedStyle(h).fontFamily);

        // entrance
        if (!this.reduce && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode)) {
          this.classList.add('lcm--anim');
          this.io = new IntersectionObserver((es) => es.forEach((e) => {
            if (e.isIntersecting) { e.target.classList.add('is-in'); e.target.classList.remove('is-pending'); this.io.unobserve(e.target); }
          }), { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
          requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
        }
        this.watchCards(this.querySelectorAll('.lcm-card'));

        // density (remembered per visitor)
        let saved = null; try { saved = localStorage.getItem('rino7-grid'); } catch (e) {}
        this.setDensity(saved === 'large' ? 'large' : 'small', false);

        // toolbar sits under the nav bar while the nav bar is showing
        this.bar = this.querySelector('[data-lcm-bar]');
        this.onScroll = () => {
          if (this.tick) return; this.tick = true;
          requestAnimationFrame(() => {
            const nav = document.querySelector('lx-header [data-bar]');
            const show = nav && !nav.classList.contains('is-hidden');
            this.bar?.style.setProperty('--lcm-top', (show ? nav.offsetHeight : 0) + 'px');
            this.tick = false;
          });
        };
        addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        // events
        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => this.onChange(e));
        this.addEventListener('submit', (e) => { if (e.target.matches('[data-lcm-form]')) { e.preventDefault(); this.closeDrawer(); } });
        this.onKey = (e) => { if (e.key === 'Escape') { this.closeDrawer(); this.closeQA(); } };
        document.addEventListener('keydown', this.onKey);
        this.onDoc = (e) => { if (!e.target.closest('.lcm-card')) this.closeQA(); };
        document.addEventListener('click', this.onDoc);
        this.onPop = () => this.load(location.href, { push: false });
        addEventListener('popstate', this.onPop);
      }
      disconnectedCallback() {
        this.io?.disconnect();
        removeEventListener('scroll', this.onScroll);
        removeEventListener('popstate', this.onPop);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDoc);
        document.documentElement.style.overflow = '';
      }

      watchCards(list) {
        let d = 0;
        list.forEach((c) => {
          if (!this.io) return;
          c.classList.add('is-pending');
          c.style.setProperty('--d', d++ % 8);
          this.io.observe(c);
        });
      }
      setDensity(mode, remember) {
        this.classList.toggle('is-large', mode === 'large');
        this.querySelectorAll('[data-lcm-density]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.lcmDensity === mode));
        if (remember) { try { localStorage.setItem('rino7-grid', mode); } catch (e) {} }
      }

      /* ---------- clicks ---------- */
      onClick(e) {
        if (e.target.closest('[data-lcm-open]')) return this.openDrawer();
        if (e.target.closest('[data-lcm-close]')) return this.closeDrawer();
        const dens = e.target.closest('[data-lcm-density]');
        if (dens) return this.setDensity(dens.dataset.lcmDensity, true);
        const next = e.target.closest('[data-lcm-next]');
        if (next) { e.preventDefault(); return this.loadMore(next); }
        const link = e.target.closest('[data-lcm-link]');
        if (link) { e.preventDefault(); this.closeDrawer(); return this.load(link.href, { push: true, scroll: true }); }
        const toggle = e.target.closest('[data-qa-toggle]');
        if (toggle) {
          const card = toggle.closest('.lcm-card'), open = !card.classList.contains('is-open');
          this.closeQA(); card.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', open);
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && !add.disabled) this.add(add);
      }
      closeQA() {
        this.querySelectorAll('.lcm-card.is-open').forEach((c) => { c.classList.remove('is-open'); c.querySelector('[data-qa-toggle]')?.setAttribute('aria-expanded', 'false'); });
      }

      /* ---------- filters + sort ---------- */
      onChange(e) {
        if (e.target.matches('[data-lcm-sort]')) {
          const f = this.querySelector('[data-lcm-sort-field]'); if (f) f.value = e.target.value;
          return this.load(this.buildUrl(e.target.value), { push: true });
        }
        if (e.target.closest('[data-lcm-form]')) {
          clearTimeout(this.ft);
          this.ft = setTimeout(() => this.load(this.buildUrl(), { push: true, keepFocus: e.target.id }), e.target.type === 'number' ? 500 : 120);
        }
      }
      buildUrl(sortOverride) {
        const form = this.querySelector('[data-lcm-form]');
        const url = new URL(form ? form.action : location.pathname, location.origin);
        if (form) new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') url.searchParams.append(k, v); });
        const sort = sortOverride || this.querySelector('[data-lcm-sort]')?.value;
        if (sort) url.searchParams.set('sort_by', sort);
        return url.toString();
      }
      async fetchSection(href) {
        const url = new URL(href, location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const r = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return new DOMParser().parseFromString(await r.text(), 'text/html');
      }
      async load(href, opts = {}) {
        const token = (this.token = (this.token || 0) + 1);
        this.classList.add('is-loading');
        let doc;
        try { doc = await this.fetchSection(href); } catch (e) { this.classList.remove('is-loading'); location.href = href; return; }
        if (token !== this.token) return;
        const fresh = doc.querySelector('lux-catalog');
        if (!fresh) { location.href = href; return; }
        const swap = (sel) => { const a = this.querySelector(sel), b = fresh.querySelector(sel); if (a && b) a.replaceWith(b); return b; };
        swap('[data-lcm-results]');
        ['[data-lcm-count]', '[data-lcm-total]', '[data-lcm-badge]', '[data-lcm-apply-n]'].forEach((sel) => {
          const a = this.querySelector(sel), b = fresh.querySelector(sel);
          if (a && b) { a.textContent = b.textContent; a.hidden = b.hidden; }
        });
        // refresh filter counts without closing the drawer or losing your place
        const body = this.querySelector('[data-lcm-filters]'), nb = fresh.querySelector('[data-lcm-filters]');
        if (body && nb) {
          const open = [...body.querySelectorAll('details')].map((d) => d.open), top = body.scrollTop;
          body.innerHTML = nb.innerHTML;
          body.querySelectorAll('details').forEach((d, i) => { if (open[i] !== undefined) d.open = open[i]; });
          body.scrollTop = top;
          if (opts.keepFocus) document.getElementById(opts.keepFocus)?.focus({ preventScroll: true });
        }
        const sortSel = this.querySelector('[data-lcm-sort]'), nSort = fresh.querySelector('[data-lcm-sort]');
        if (sortSel && nSort) sortSel.value = nSort.value;
        this.classList.remove('is-loading');
        this.watchCards(this.querySelectorAll('[data-lcm-results] .lcm-card'));
        const clean = new URL(href, location.origin); clean.searchParams.delete('section_id');
        if (opts.push !== false) history.pushState({ lcm: true }, '', clean.toString());
        if (opts.scroll) this.bar?.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'start' });
      }
      async loadMore(btn) {
        btn.classList.add('is-loading'); btn.textContent = 'Loading…';
        let doc;
        try { doc = await this.fetchSection(btn.href); } catch (e) { location.href = btn.href; return; }
        const grid = this.querySelector('[data-lcm-grid]');
        const cards = [...doc.querySelectorAll('[data-lcm-grid] > .lcm-card')];
        cards.forEach((c) => grid.append(c));
        this.watchCards(cards);
        const more = this.querySelector('[data-lcm-more]'), nMore = doc.querySelector('[data-lcm-more]');
        if (more && nMore) more.replaceWith(nMore);
        cards[0]?.querySelector('a')?.focus({ preventScroll: true });
      }

      /* ---------- drawer ---------- */
      openDrawer() {
        const d = this.querySelector('[data-lcm-drawer]'); if (!d) return;
        d.hidden = false; this.drawerOpen = true;
        document.documentElement.style.overflow = 'hidden';
        this.querySelector('[data-lcm-open]')?.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
        setTimeout(() => d.querySelector('[data-lcm-close].lcm-x')?.focus(), 60);
      }
      closeDrawer() {
        const d = this.querySelector('[data-lcm-drawer]'); if (!d || !this.drawerOpen) return;
        this.drawerOpen = false;
        d.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        const btn = this.querySelector('[data-lcm-open]'); btn?.setAttribute('aria-expanded', 'false');
        setTimeout(() => { if (!this.drawerOpen) d.hidden = true; }, this.reduce ? 0 : 600);
        btn?.focus({ preventScroll: true });
      }

      /* ---------- quick add ---------- */
      async add(btn) {
        if (this.busy) return;
        this.busy = true; btn.classList.add('is-loading');
        let ok = false, msg = 'Could not add to bag. Please try again.';
        try {
          const r = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.add), quantity: 1 }] }) });
          const d = await r.json().catch(() => ({}));
          ok = r.ok && !d.status; if (!ok) msg = d.description || d.message || msg;
        } catch (e) {}
        btn.classList.remove('is-loading'); this.busy = false;
        if (!ok) return this.toast(msg, true);
        const plus = btn.closest('.lcm-card').querySelector('.lcm-plus');
        this.closeQA();
        if (plus) {
          plus.classList.add('is-done');
          plus.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
          setTimeout(() => { plus.classList.remove('is-done'); plus.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'; }, 1800);
        }
        this.toast('Added to bag');
        try {
          const cart = await (await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })).json();
          document.querySelectorAll('.cart-count-badge').forEach((b) => { b.textContent = cart.item_count; b.dataset.count = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        } catch (e) {}
      }
      toast(msg, isError) {
        const t = this.querySelector('[data-lcm-toast]');
        this.querySelector('[data-lcm-toast-msg]').textContent = msg;
        t.querySelector('a').hidden = !!isError;
        t.classList.add('is-show');
        clearTimeout(this.tt); this.tt = setTimeout(() => t.classList.remove('is-show'), isError ? 3500 : 4000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lux-footer')) {
    customElements.define('lux-footer', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        // Wordmark: scale the brand name so the letters themselves sit flush with both edges
        this.mark = this.querySelector('[data-mark]');
        if (this.mark) {
          this.fit = () => {
            const m = this.mark, box = m.parentElement, avail = box.clientWidth;
            const text = m.textContent.trim();
            if (!avail || !text) return;
            m.style.fontSize = '100px';
            m.style.marginLeft = '0px';
            const W = m.getBoundingClientRect().width;
            if (!W) return;
            let ink = W, lead = 0;
            try {
              const cs = getComputedStyle(m);
              const ctx = (this._cv || (this._cv = document.createElement('canvas'))).getContext('2d');
              ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' 100px ' + cs.fontFamily;
              const ls = parseFloat(cs.letterSpacing) || 0;
              const first = ctx.measureText(Array.from(text)[0]);
              const last = ctx.measureText(Array.from(text).slice(-1)[0]);
              lead = -first.actualBoundingBoxLeft;                       // empty space before the first letter
              const tail = last.width - last.actualBoundingBoxRight + ls; // empty space after the last letter
              if (isFinite(lead) && isFinite(tail) && W - lead - tail > W * 0.5) ink = W - lead - tail; else lead = 0;
            } catch (e) { lead = 0; ink = W; }
            const k = avail / ink;
            m.style.fontSize = (100 * k).toFixed(2) + 'px';
            m.style.marginLeft = (-lead * k).toFixed(2) + 'px';
          };
          this.fit();
          if ('ResizeObserver' in window) { this.ro = new ResizeObserver(() => this.fit()); this.ro.observe(this.mark.parentElement); }
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fit());
        }

        // Columns: always open on desktop, accordions on phones
        this.cols = [...this.querySelectorAll('.ft-col')];
        this.mq = matchMedia('(max-width: 749px)');
        this.sync = () => this.cols.forEach((d) => { d.open = !this.mq.matches; });
        this.sync();
        this.mq.addEventListener ? this.mq.addEventListener('change', this.sync) : this.mq.addListener(this.sync);
        this.cols.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => { if (!this.mq.matches) e.preventDefault(); }));

        // Back to top
        this.querySelector('[data-top]')?.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });

      }
      disconnectedCallback() {
        this.ro?.disconnect();
        if (this.mq) this.mq.removeEventListener ? this.mq.removeEventListener('change', this.sync) : this.mq.removeListener(this.sync);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lx-header')) {
    /* Types words letter by letter, holds, deletes, moves to the next word */
    class LxTyper {
      constructor(el, words, reduce) { this.el = el; this.words = words; this.reduce = reduce; this.i = 0; this.n = 0; this.del = false; this.on = false; if (reduce) el.textContent = words[0] || ''; }
      start() { if (this.on || !this.words.length || this.reduce) return; this.on = true; this.step(); }
      stop() { this.on = false; clearTimeout(this.t); }
      step() {
        if (!this.on) return;
        const w = this.words[this.i];
        if (!this.del) {
          this.n++; this.el.textContent = w.slice(0, this.n);
          if (this.n >= w.length) { this.del = true; this.t = setTimeout(() => this.step(), 1800); return; }
          this.t = setTimeout(() => this.step(), 70 + Math.random() * 60);
        } else {
          this.n--; this.el.textContent = w.slice(0, this.n);
          if (this.n <= 0) { this.del = false; this.i = (this.i + 1) % this.words.length; this.t = setTimeout(() => this.step(), 380); return; }
          this.t = setTimeout(() => this.step(), 34);
        }
      }
    }
    window.LxTyper = LxTyper;

    customElements.define('lx-header', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.bar = this.querySelector('[data-bar]');
        this.spacer = this.querySelector('[data-spacer]');
        this.overlay = this.dataset.overlay === 'true';
        this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

        // height: reserve space on normal pages, let content slide under on transparent pages
        this.measure = () => {
          const h = this.bar.offsetHeight;
          document.documentElement.style.setProperty('--lx-header-h', h + 'px');
          this.spacer.style.height = this.overlay ? '0px' : h + 'px';
        };
        this.flattenWrappers();
        this.pull = () => { clearTimeout(this.pt); this.pt = setTimeout(() => { this.flattenWrappers(); this.measure(); this.pullContent(); }, 60); };
        this.pullContent();
        if (document.readyState !== 'complete') addEventListener('load', this.pull, { once: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.pull);
        addEventListener('resize', this.pull, { passive: true });
        this.measure();
        if ('ResizeObserver' in window) { this.ro = new ResizeObserver(this.measure); this.ro.observe(this.bar); }

        // scroll: solid after the top, hide while scrolling down, return on scroll up
        this.lastY = scrollY;
        this.onScroll = () => {
          if (this.tick) return;
          this.tick = true;
          requestAnimationFrame(() => {
            const y = Math.max(0, scrollY), dy = y - this.lastY, h = this.bar.offsetHeight;
            this.bar.classList.toggle('is-solid', y > 8 || this.busy());
            if (this.dataset.hideOnScroll === 'true' && !this.busy()) {
              if (y > h * 2 && dy > 6) this.bar.classList.add('is-hidden');
              else if (dy < -6 || y <= h) this.bar.classList.remove('is-hidden');
            }
            this.lastY = y; this.tick = false;
          });
        };
        addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        this.initPanels();
        this.initDrawer();
        this.initSearch();
        this.initCart();
        this.initTyping();
        this.onKey =(e) => { if (e.key === 'Escape') { this.closePanels(); this.closeDrawer(); this.closeSearch(); } };
        document.addEventListener('keydown', this.onKey);
      }
      disconnectedCallback() {
        removeEventListener('scroll', this.onScroll);
        removeEventListener('resize', this.pull);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDocClick);
        this.ro?.disconnect();
        document.documentElement.style.overflow = '';
      }
      // Remove padding/background from the boxes the theme wraps around this header
      // (e.g. a Custom Liquid section or a header-group wrapper), so no strip appears above the page.
      flattenWrappers() {
        let child = this, el = this.parentElement;
        while (el && el !== document.body && el !== document.documentElement) {
          if (el.matches('main, #MainContent, [role="main"]')) break;
          const others = [...el.children].filter((c) => c !== child && !/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(c.tagName) && c.getBoundingClientRect().height > 0);
          if (others.length) break;
          // 'important' beats theme rules that use !important (e.g. HTML/Liquid section padding)
          [['padding', '0'], ['margin', '0'], ['min-height', '0'], ['height', 'auto'], ['border', '0'], ['background', 'transparent'], ['box-shadow', 'none']]
            .forEach(([p, v]) => el.style.setProperty(p, v, 'important'));
          // a sticky theme wrapper would leave an invisible band at the top when the bar hides
          if (getComputedStyle(el).position === 'sticky') { el.style.setProperty('position', 'relative', 'important'); el.style.setProperty('top', 'auto', 'important'); }
          child = el; el = el.parentElement;
        }
      }

      // Transparent pages: if the theme leaves an empty gap above the first image/banner
      // (section padding, spacing between sections), pull the page up so the image meets the top edge.
      pullContent() {
        if (!this.overlay || this.dataset.pull === 'false') return;
        const main = document.querySelector('#MainContent') || document.querySelector('main') || document.querySelector('[role="main"]');
        if (!main) return;
        main.style.removeProperty('margin-top');
        const isVisual = (el) => {
          if (el.closest('lx-header')) return false;
          const r = el.getBoundingClientRect();
          if (r.height < 40 || r.width < innerWidth * 0.5) return false;
          if (/^(IMG|VIDEO|PICTURE|CANVAS|IFRAME)$/.test(el.tagName)) return true;
          const cs = getComputedStyle(el);
          if (cs.backgroundImage && cs.backgroundImage !== 'none') return true;
          const bg = cs.backgroundColor, body = getComputedStyle(document.body).backgroundColor;
          return bg && bg !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(bg) && bg !== body;
        };
        let target = null;
        const walker = document.createTreeWalker(main, NodeFilter.SHOW_ELEMENT);
        for (let n = walker.nextNode(), i = 0; n && i < 400; n = walker.nextNode(), i++) { if (isVisual(n)) { target = n; break; } }
        if (!target) return;
        const gap = Math.round(target.getBoundingClientRect().top + scrollY);
        if (gap <= 0 || gap > 200) return;
        // never cover real content: abort if any text sits inside the gap
        const tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
        for (let t = tw.nextNode(); t; t = tw.nextNode()) {
          if (!t.textContent.trim() || (t.parentElement && t.parentElement.closest('lx-header, script, style, noscript'))) continue;
          const range = document.createRange(); range.selectNodeContents(t);
          const rr = range.getBoundingClientRect();
          if (rr.height > 0 && rr.width > 0 && rr.top + scrollY < gap && rr.bottom + scrollY > 0) return;
        }
        main.style.setProperty('margin-top', (parseFloat(getComputedStyle(main).marginTop) || 0) - gap + 'px', 'important');
      }
      busy() { return !!(this.querySelector('.lx-nav__item.is-open') || this.drawerOpen || this.searchOpen); }

      /* desktop dropdowns: hover (CSS) + click / keyboard */
      initPanels() {
        this.querySelectorAll('[data-panel-btn]').forEach((btn) => {
          const item = btn.closest('.lx-nav__item');
          btn.addEventListener('click', () => {
            const open = !item.classList.contains('is-open');
            this.closePanels();
            item.classList.toggle('is-open', open);
            btn.setAttribute('aria-expanded', open);
            this.bar.classList.toggle('is-solid', open || scrollY > 8);
          });
          item.addEventListener('mouseenter', () => btn.setAttribute('aria-expanded', 'true'));
          item.addEventListener('mouseleave', () => { if (!item.classList.contains('is-open')) btn.setAttribute('aria-expanded', 'false'); });
          item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } });
        });
        this.onDocClick = (e) => { if (!e.target.closest('.lx-nav__item')) this.closePanels(); };
        document.addEventListener('click', this.onDocClick);
      }
      closePanels() {
        this.querySelectorAll('.lx-nav__item.is-open').forEach((i) => { i.classList.remove('is-open'); i.querySelector('[data-panel-btn]')?.setAttribute('aria-expanded', 'false'); });
        this.bar.classList.toggle('is-solid', scrollY > 8);
      }

      /* phone menu */
      initDrawer() {
        this.drawer = this.querySelector('[data-drawer]');
        this.burger = this.querySelector('[data-open-drawer]');
        this.burger?.addEventListener('click', () => this.openDrawer());
        if (!this.drawer) return;
        this.drawerScroll = this.drawer.querySelector('[data-dr-scroll]');
        this.drawer.addEventListener('click', (e) => {
          if (e.target.closest('[data-close-drawer]')) return this.closeDrawer();
          const go = e.target.closest('[data-dr-go]');
          if (go) return this.drawerView(go.dataset.drGo, go);
          if (e.target.closest('[data-dr-back]')) return this.drawerView('root');
          if (e.target.closest('a')) this.closeDrawer();
        });
        this.drawer.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { e.stopPropagation(); this.view && this.view !== 'root' ? this.drawerView('root') : this.closeDrawer(); }
          if (e.key === 'Tab') {
            // keep focus inside the open menu
            const f = [...this.drawer.querySelectorAll('.lx-drawer__top button, .lx-dr__view.is-active a, .lx-dr__view.is-active button, .lx-dr__foot a')].filter((el) => el.offsetParent);
            if (!f.length) return;
            const first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
          }
        });
        const t = this.drawer.querySelector('[data-typer-drawer]');
        const words = (this.dataset.phrases || '').split(',').map((w) => w.trim()).filter(Boolean);
        if (t && words.length && typeof LxTyper === 'function') this.drawerTyper = new LxTyper(t, words, this.reduce);
      }
      drawerView(name, opener) {
        const views = this.drawer.querySelectorAll('[data-dr-view]');
        const next = this.drawer.querySelector('[data-dr-view="' + name + '"]');
        if (!next) return;
        views.forEach((v) => { const on = v === next; v.classList.toggle('is-active', on); v.setAttribute('aria-hidden', on ? 'false' : 'true'); });
        this.drawer.querySelectorAll('[data-dr-go]').forEach((b) => b.setAttribute('aria-expanded', b === opener ? 'true' : 'false'));
        const prev = this.view; this.view = name;
        if (this.drawerScroll) this.drawerScroll.scrollTo({ top: 0, behavior: this.reduce ? 'auto' : 'smooth' });
        setTimeout(() => {
          if (name === 'root') this.drawer.querySelector('[data-dr-go="' + prev + '"]')?.focus({ preventScroll: true });
          else next.querySelector('[data-dr-back]')?.focus({ preventScroll: true });
        }, 60);
      }
      openDrawer() {
        if (!this.drawer) return;
        clearTimeout(this.drawerTimer);
        this.drawerOpen = true;
        this.drawer.hidden = false;
        this.drawer.classList.remove('is-closing');
        document.documentElement.style.overflow = 'hidden';
        this.burger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => requestAnimationFrame(() => this.drawer.classList.add('is-open')));
        setTimeout(() => this.drawer.querySelector('.lx-close')?.focus({ preventScroll: true }), 80);
        this.drawerTyper?.start();
      }
      closeDrawer() {
        if (!this.drawerOpen) return;
        this.drawerOpen = false;
        this.drawer.classList.add('is-closing');
        this.drawer.classList.remove('is-open');
        if (!this.searchOpen) document.documentElement.style.overflow = '';
        this.burger.setAttribute('aria-expanded', 'false');
        this.drawerTyper?.stop();
        this.drawerTimer = setTimeout(() => {
          if (this.drawerOpen) return;
          this.drawer.hidden = true;
          this.drawer.classList.remove('is-closing');
          if (this.view && this.view !== 'root') this.drawerView('root');
        }, this.reduce ? 0 : 520);
        this.burger.focus({ preventScroll: true });
      }

      /* search with live suggestions */
      initSearch() {
        this.search = this.querySelector('[data-search]');
        if (!this.search) return;
        this.input = this.search.querySelector('[data-search-input]');
        this.results = this.search.querySelector('[data-search-results]');
        this.querySelectorAll('[data-open-search]').forEach((b) => b.addEventListener('click', () => { this.closeDrawer(); this.openSearch(); }));
        this.search.querySelectorAll('[data-close-search]').forEach((b) => b.addEventListener('click', () => this.closeSearch()));
        this.input.addEventListener('input', () => { clearTimeout(this.st); this.st = setTimeout(() => this.suggest(), 220); this.syncField(); });
      }
      /* typing words in the header bar (desktop) and inside the open search panel */
      initTyping() {
        const words = (this.dataset.phrases || '').split(',').map((w) => w.trim()).filter(Boolean);
        const bar = this.querySelector('[data-typer]'), panel = this.querySelector('[data-typer-panel]');
        this.field = this.querySelector('[data-search-field]');
        if (!words.length) return;
        const reduce = this.reduce;
        if (bar) {
          this.barTyper = new LxTyper(bar, words, reduce);
          const mq = matchMedia('(min-width: 1200px)');
          const run = () => (mq.matches && !document.hidden && !this.searchOpen ? this.barTyper.start() : this.barTyper.stop());
          mq.addEventListener ? mq.addEventListener('change', run) : mq.addListener(run);
          document.addEventListener('visibilitychange', run);
          this.runBar = run; run();
        }
        if (panel) this.panelTyper = new LxTyper(panel, words.slice(1).concat(words[0]), reduce);
      }
      syncField() {
        if (!this.field) return;
        const has = this.input.value.length > 0;
        this.field.classList.toggle('has-value', has);
        if (this.panelTyper) has || !this.searchOpen ? this.panelTyper.stop() : this.panelTyper.start();
      }
      openSearch() {
        this.searchOpen = true;
        this.search.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(() => requestAnimationFrame(() => this.search.classList.add('is-open')));
        setTimeout(() => this.input.focus(), 60);
        this.syncField();
        if (this.runBar) this.runBar();
      }
      closeSearch() {
        if (!this.searchOpen) return;
        this.searchOpen = false;
        this.search.classList.remove('is-open');
        if (!this.drawerOpen) document.documentElement.style.overflow = '';
        setTimeout(() => { if (!this.searchOpen) this.search.hidden = true; }, this.reduce ? 0 : 450);
        if (this.panelTyper) this.panelTyper.stop();
        if (this.runBar) this.runBar();
      }
      money(v) {
        let cents = typeof v === 'number' ? Math.round(v) : String(v).includes('.') ? Math.round(parseFloat(v) * 100) : parseInt(v, 10) || 0;
        const f = this.dataset.moneyFormat || 'Rs. {{amount}}';
        const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
        const num = (prec, thou, dec) => { const p = (cents / 100).toFixed(prec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (p[1] ? dec + p[1] : ''); };
        let val = !m ? String(cents / 100) : /comma_separator/.test(m[1]) ? num(/no_decimals/.test(m[1]) ? 0 : 2, '.', ',') : num(/no_decimals/.test(m[1]) ? 0 : 2, ',', '.');
        if (cents % 100 === 0) val = val.replace(/[.,]00$/, '');
        const t = document.createElement('textarea'); t.innerHTML = m ? f.replace(m[0], val) : val; return t.value;
      }
      async suggest() {
        const q = this.input.value.trim();
        if (q.length < 2) { this.results.replaceChildren(); return; }
        const token = (this.token = (this.token || 0) + 1);
        let products = [];
        try {
          const r = await fetch(this.dataset.suggestUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last');
          products = ((await r.json()).resources.results.products) || [];
        } catch (e) { products = null; }
        if (token !== this.token) return;
        const el = (t, c, txt) => { const e = document.createElement(t); if (c) e.className = c; if (txt != null) e.textContent = txt; return e; };
        const frag = document.createDocumentFragment();
        if (!products || !products.length) {
          frag.append(el('p', 'lx-res__empty', products ? 'No results for “' + q + '”.' : 'Press Enter to search for “' + q + '”.'));
        } else {
          frag.append(el('p', 'lx-res__label', 'Products'));
          const ul = el('ul', 'lx-res__grid'); ul.setAttribute('role', 'list');
          products.forEach((p) => {
            const li = el('li', 'lx-res__item'), a = el('a');
            a.href = p.url;
            const src = p.featured_image && (p.featured_image.url || p.featured_image) || p.image;
            if (src) { const im = el('img', 'lx-res__img'); im.src = String(src) + (String(src).includes('?') ? '&' : '?') + 'width=400'; im.alt = ''; im.loading = 'lazy'; a.append(im); }
            a.append(el('span', 'lx-res__title', p.title), el('span', 'lx-res__price', this.money(p.price)));
            li.append(a); ul.append(li);
          });
          frag.append(ul);
          const all = el('a', 'lx-res__all', 'View all results'); all.href = this.input.form.action + '?type=product&q=' + encodeURIComponent(q);
          frag.append(all);
        }
        this.results.replaceChildren(frag);
      }

      /* bag count stays in sync with every add-to-bag on the site */
      initCart() {
        const set = (n) => this.querySelectorAll('[data-cart-count]').forEach((c) => { c.textContent = n; });
        const refresh = async () => { try { set((await (await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })).json()).item_count); } catch (e) {} };
        document.addEventListener('cart:updated', (e) => { const n = e.detail && e.detail.cart && e.detail.cart.item_count; n != null ? set(n) : refresh(); });
        document.addEventListener('cart:refresh', refresh);
        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
        addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
